import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=b72920a8&scoped=true"
import script from "./Fabric.vue?vue&type=script&lang=js"
export * from "./Fabric.vue?vue&type=script&lang=js"
import style0 from "./Fabric.vue?vue&type=style&index=0&id=b72920a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72920a8",
  null
  
)

export default component.exports